import React from "react";
import styles from "./index.module.css"

export default ({ children }) => (
    <div className={styles['sidebar-left']} style={{ margin: "0"}}>
        <div className={styles['sidebar-left-picture']} style={{width: "100%"}}>{children}</div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/sidebar-left.js